"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeLocationConfirmModal = void 0;
const React = require("react");
const react_1 = require("react");
const Modal_1 = require("../../../../../components/base/structure/Modal");
const dialogs_1 = require("../../../../../types/dialogs");
const react_router_dom_1 = require("react-router-dom");
const retailOrderingRoutes_1 = require("../../../../../apps/spg/ordering/components/RetailOrderingApp/retailOrderingRoutes");
const SalesOrderContext_1 = require("../../contexts/SalesOrderContext");
const RetailLocationsContext_1 = require("../../contexts/RetailLocationsContext");
/**
 * Modal asking for customer's confirmation before changing location.
 * This is to prevent accidental clicks on the change button as doing
 * so would reset the cart.
 */
const ChangeLocationConfirmModal = ({ show, dismiss }) => {
    const history = (0, react_router_dom_1.useHistory)();
    const { resetCart, setRequestedReadyTime } = (0, react_1.useContext)(SalesOrderContext_1.SalesOrderContext);
    const { setRetailLocation } = (0, react_1.useContext)(RetailLocationsContext_1.RetailLocationsContext);
    return (React.createElement(Modal_1.Modal, { open: show, onClose: null, size: dialogs_1.TDialogSizes.Medium, appMode: true, showCloseIcon: false, closeOnOverlayClick: true, closeOnEsc: true },
        React.createElement(Modal_1.ModalHeader, null, "You are about to change store"),
        React.createElement(Modal_1.ModalBody, null, "This will clear your current cart and you will lose your progress."),
        React.createElement(Modal_1.ModalFooter, { onAccept: async () => {
                dismiss();
                await resetCart(true);
                history.push(retailOrderingRoutes_1.retailOrderingPaths.restaurant, history.location.pathname);
            }, onCancel: dismiss, acceptLabel: "proceed" })));
};
exports.ChangeLocationConfirmModal = ChangeLocationConfirmModal;
//# sourceMappingURL=index.js.map